<template>
    <section :id="sectionId" class="mb-10">
        <h2 class="text-xl font-semibold mb-2">CellXpert</h2>
        <Accordion :multiple="true" v-model:activeIndex="accordionActive">
            <AccordionTab header="Setting up Postbacks">
                <PostbackUrlBlock v-bind="templates" />
            </AccordionTab>
        </Accordion>
    </section>
</template>

<script setup>
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import PostbackUrlBlock from './PostbackUrlBlock.vue';
import { getPostbackTemplates } from '@/utils/postback-templates';
import { useHelpSection } from './useHelpSection';

const templates = getPostbackTemplates('cellxpert');
const { sectionId, accordionActive } = useHelpSection('postbacks-cellxpert');
</script>
